import ApiBase from '@/api/api-base'
import { ACTIVE_BASE_REST } from '@/api/constants'

export default class FinancialTariffEmployee extends ApiBase {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/tariff/employee`)
  }

  statistics(courierId, filter, showProgress) {
    return this._request({
      action: `statistics/${courierId}`,
      method: 'GET',
      params: filter,
      showProgress
    })
  }
}
